import React from 'react';
import clsx from 'clsx';
import { Grid, Typography, Hidden } from '@material-ui/core';
import { WkblScript } from 'components/ScriptListView';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/reducers/type';
import { useStyles } from 'components/ScriptListView/styles';
import WkblScriptVO from 'commons/vo/WkblScriptVO';

function WkblScriptListView() {
  const classes = useStyles();
  const { isLoading, wkblScriptList, pagination } = useSelector(
    (state: RootState) => state.wkblScript,
  );

  return (
    <div className={classes.root}>
      <Hidden mdDown>
        <div className={clsx(classes.headerContainer, classes.row)}>
          <span className={clsx(classes.headerColumn, classes.seasonContainer)}>시즌</span>
          <span className={clsx(classes.headerColumn, classes.typeContainer)}>구분</span>
          <span className={clsx(classes.headerColumn, classes.teamContainer)}>홈 팀</span>
          <span className={clsx(classes.headerColumn, classes.teamContainer)}>원정 팀</span>
          <span className={clsx(classes.headerColumn, classes.titleContainer)}>기록 명</span>
          <span className={clsx(classes.headerColumn, classes.timeContainer)}>시작 시간</span>
          <span className={clsx(classes.headerColumn, classes.timeContainer)}>끝 시간</span>
          <span className={clsx(classes.headerColumn, classes.gameDateContainer)}>경기 일자</span>
        </div>
      </Hidden>
      {wkblScriptList.map((wkblScript: WkblScriptVO, index: number) => {
        return <WkblScript key={`${wkblScript.id}_${index}`} script={wkblScript} index={index} />;
      })}
    </div>
  );
}

export default WkblScriptListView;
